/**
 * set video
 */

const videoContent = () => {
  // const $videoContent = document.querySelector('.js-videoContent')
  const $videoContent = document.querySelectorAll('.js-videoContent')
  if ($videoContent != null) {
    const setVideo = () => {
      for (let i = 0; i < $videoContent.length; i++) {
        $videoContent[i].textContent = null
        const videoClass = $videoContent[i].getAttribute('data-class')
        const pcPath = $videoContent[i].getAttribute('data-pc')
        const spPath = $videoContent[i].getAttribute('data-sp')
        const commonPath = '/tw/zh/contents/lifewear-magazine/assets/img'

        let videoPath
        if (window.innerWidth >= 768) {
          videoPath = commonPath + pcPath
        } else {
          videoPath = commonPath + spPath
        }
        let $video = '<video class="' + videoClass + '" autoplay="" muted="muted" playsinline="" loop="" src="' + videoPath + '"></video>'
        $videoContent[i].oncontextmenu = function () { return false; }
        $videoContent[i].onselectstart = function () { return false; }
        $videoContent[i].onmousedown = function () { return false; }
        $videoContent[i].innerHTML = $video
      }
    }

    setVideo()

    let currentWidth = window.innerWidth;
    let resizeTimer

    window.addEventListener('resize', function (event) {
      if (!resizeTimer) {
        clearTimeout(resizeTimer)
      }
      resizeTimer = setTimeout(function () {
        if (currentWidth == window.innerWidth) {
          return
        }
        setVideo()
        currentWidth = window.innerWidth
      }, 200)
    })

    for (let i = 0; i < $videoContent.length; i++) {
      $videoContent[i].addEventListener('click', () => {
        const video = $videoContent[i].querySelector('video')
        if (!$videoContent[i].classList.contains('is-paused')) {
          $videoContent[i].classList.add('is-paused')
          video.pause()
        } else {
          $videoContent[i].classList.remove('is-paused')
          video.play()
        }
      })
    }

  }

}
export { videoContent }
